import ReactDOM from "react-dom";
import React from "react";

const BackgroundPortal = () => {
  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
      <div className="flex w-[200%] h-full animate-waveLoop">
        <img src="/bg.svg" alt="wave" className="w-1/2 h-full object-cover" />
        <img src="/bg.svg" alt="wave" className="w-1/2 h-full object-cover" />
      </div>
    </div>,
    document.getElementById("background-root")
  );
};

export default BackgroundPortal;
